import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "banner" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { style: {"text-align":"left"} }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, "惠友科技"),
  /*#__PURE__*/_createElementVNode("div", { class: "sub-title" }, "Huiyou Technology Inc.")
], -1)
const _hoisted_3 = { class: "info-item" }
const _hoisted_4 = { class: "icon" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_6 = ["href"]
const _hoisted_7 = {
  key: 0,
  class: "mobile-bar"
}
const _hoisted_8 = { class: "current-page" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, "成功案例", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, "知识产权", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, "关于我们", -1)
const _hoisted_12 = { class: "publicity" }
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "publicity-text" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", null, "版权所有  北京惠友科技有限公司 CopyRight©2022-2032 All Rights Reserved", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", null, "京公网安备1104564864646 违法和不良信息举报电话：010-52815281", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_message = _resolveComponent("message")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_Menu = _resolveComponent("Menu")!
  const _component_Memo = _resolveComponent("Memo")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_Document = _resolveComponent("Document")!
  const _component_User = _resolveComponent("User")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", null, [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, [
            _createVNode(_component_el_icon, { size: 20 }, {
              default: _withCtx(() => [
                _createVNode(_component_message)
              ]),
              _: 1
            })
          ]),
          _hoisted_5,
          _createElementVNode("a", { href: _ctx.mailHref }, _toDisplayString(_ctx.aboutUs?.email), 9, _hoisted_6)
        ])
      ]),
      _createElementVNode("nav", null, [
        (_ctx.isMobile)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$route.meta.title), 1),
              _createVNode(_component_el_icon, {
                class: "menu-toggle",
                size: 24,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.menuOpen = !_ctx.menuOpen))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Menu)
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        _withDirectives(_createVNode(_component_el_menu, {
          class: "el-menu-demo",
          "active-text-color": "#ff6c00",
          "background-color": "#2b2b2b",
          "default-active": _ctx.$route.path,
          "text-color": "#fff",
          router: "",
          mode: _ctx.isMobile ? 'vertical' : 'horizontal'
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_menu_item, { index: "/" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_Memo)
                  ]),
                  _: 1
                }),
                _hoisted_9
              ]),
              _: 1
            }),
            _createVNode(_component_el_menu_item, { index: "/intellectualproperty" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_Document)
                  ]),
                  _: 1
                }),
                _hoisted_10
              ]),
              _: 1
            }),
            _createVNode(_component_el_menu_item, { index: "/about" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_User)
                  ]),
                  _: 1
                }),
                _hoisted_11
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["default-active", "mode"]), [
          [_vShow, !_ctx.isMobile || _ctx.menuOpen]
        ])
      ])
    ]),
    _createElementVNode("main", null, [
      _createVNode(_component_router_view)
    ]),
    _createElementVNode("footer", null, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", null, [
          _createElementVNode("img", {
            src: _ctx.aboutUs?.service_number,
            style: {"height":"80px"}
          }, null, 8, _hoisted_13)
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", null, "备案号      " + _toDisplayString(_ctx.aboutUs?.icp), 1),
          _createElementVNode("div", null, "通讯地址  " + _toDisplayString(_ctx.aboutUs?.address), 1),
          _hoisted_15,
          _hoisted_16
        ])
      ])
    ])
  ], 64))
}